import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Container, Card } from "react-bootstrap";

const PopUpNotification = ({ show, handleClose, buttonText, title, textBody, onClickButton }) => {
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        className={`notification ${show ? 'notification-modal-show' : ''}`}  
      >
        <Modal.Body className="popup-notification-modal-body ">
          <Container>
            <Card className="mx-auto p-3 rounded-border-px custom-shadow">
              <Card.Body className="d-flex flex-column align-items-center">
                <span className="red-bulb custom-shadow-bold"></span>
                <p className="modal-title mt-2">{title}</p>
                <p className="mt-2">{textBody}</p>
                  <div className="text-center mt-auto">
                    <Button
                      type="submit"
                      className="w-100 mt-2 custom-button-primary custom-bg-primary"
                      onClick={onClickButton}
                    >
                      {buttonText}
                    </Button>
                  </div>
              </Card.Body>
            </Card>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopUpNotification;